import React from 'react';
import Message from 'components/Message';
import messages from '../Schedules.messages';

export const STATUS_FILTER_OPTIONS = [
  {
    key: 'PUBLISHED',
    label: <Message message={messages.board.filters.published} />,
    query: 'status:published',
  },
  {
    key: 'DRAFTS',
    label: <Message message={messages.board.filters.drafts} />,
    query: 'status:draft',
  },
  {
    key: 'DISABLED',
    label: <Message message={messages.board.filters.disabled} />,
    query: 'status:disabled',
  },
];

export const RECURRING_FILTER_OPTIONS = [
  {
    key: 'RECURRING',
    label: <Message message={messages.board.filters.recurring} />,
    query: 'recurrence:true',
  },
  {
    key: 'ONE_TIME',
    label: <Message message={messages.board.filters.oneTime} />,
    query: 'recurrence:false',
  },
];

export const FILTERS_OPTIONS = [...RECURRING_FILTER_OPTIONS, ...STATUS_FILTER_OPTIONS];
